import { DropdownButtonType, List, ListItem, SingleSelectDropdown, SingleSelectDropdownProps } from '@tableau/widgets';
import React = require('react');
import { style } from 'typestyle';

import { IIdentityPool } from '~src/authentication/serverApi/types/identityPools/IIdentityPool';
import { Messages } from '~src/codegen/Localize';
import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';

const DefaultDropdownMenuWidth = 400;
const defaultSiteRoleDropdownWidth = DefaultDropdownMenuWidth - CommonStyles.Sizes.DefaultSpace - (2 * CommonStyles.Sizes.TextBoxBorderSize);

export interface IdentityPoolsPickerProps extends Omit<SingleSelectDropdownProps, 'list' | 'type' | 'label'> {
  onOptionSelected: (identityPoolUuid: IIdentityPool) => void;
  identityPools: IIdentityPool[];
  currentSelection: IIdentityPool;
}

const ContentContainerStyle: React.CSSProperties = {
  paddingTop: '6px',
  height: '47px'
};

const PoolNameStyle: React.CSSProperties = {
  paddingTop: '8px',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: '12px',
  color: '#333333'
};

const PoolInfoStyle: React.CSSProperties = {
  paddingTop: '8px',
  paddingBottom: '4px',
  paddingLeft: '3px',
  fontFamily: 'BentonSans-Book',
  fontStyle: 'normal',
  fontWeight: 350,
  fontSize: '12px',
  lineHeight: '15px',
  color: '#666666'
};

export function IdentityPoolsPicker(props: IdentityPoolsPickerProps) {

  return <div style={{ display: 'inline-block' }}>
    <SingleSelectDropdown
      className={style({
        width: defaultSiteRoleDropdownWidth,
      })}
      children={props.currentSelection?.name}
      value={props.currentSelection?.id}
      onChange={(id) => props.onOptionSelected(props.identityPools.find(x => x.id === id) ?? null)}
      testId={'identity-pools-picker'}
      list={<List items={getIdentityPoolItems()} />}
      label={Messages.identityPools_AddUsersDialog_IdentityPools_PoolPickerLabel()}
      type={DropdownButtonType.Outline}
    />
  </div>;

  function getIdentityPoolItems(): ListItem[] {
    return props.identityPools.map(x => {
      return {
        content: getIdentityPoolItemContent(x),
        value: x.id,
        testId: 'identity-pools-picker-option-' + x.id,
      };
    });
  }

  function getIdentityPoolItemContent(identityPool: IIdentityPool): JSX.Element {
   const poolInfo = Messages.identityStore() + ' = '
    + identityPool.identityStoreType + ' | ' + Messages.authentication() + ' = ' + identityPool.authType;
   return (
    <div style={ContentContainerStyle}>
      <div style={PoolNameStyle}>{identityPool.name}</div>
      <div style={PoolInfoStyle}>{poolInfo}</div>
    </div>
  );
  }
}
